import { all, } from "redux-saga/effects";
import { statusAppController } from "../modulos/root/root.controller"
import { usuarioController } from "../modulos/usuario/usuario.controller"
import { procedimentoController } from "../modulos/procedimento/procedimento.controller"
import { pacienteController } from "../modulos/paciente/paciente.controller"
import { atendimentoController } from "../modulos/atendimento/atendimento.controller"

export default function* rootSaga():any {
    return yield all([
        ...statusAppController.actionEffects,
        ...usuarioController.actionEffects,
        ...procedimentoController.actionEffects,
        ...pacienteController.actionEffects,
        ...atendimentoController.actionEffects,
        
    ])
}
